import { loadStripe } from '@stripe/stripe-js';
import { config } from '../config';
import * as stripeJs from '@stripe/stripe-js';

export const stripePromise = loadStripe(config.stripeKey);

export const stripeCustomFont = [
	{
		cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap"'
	}
] as Array<stripeJs.CssFontSource>;

export const stripeFormAppearance = {
	theme: 'night',
	labels: 'above',
	variables: {
		fontFamily: 'Inter',
		borderRadius: '2px',
		colorBackground: '#2A2A2A',
		colorPrimary: '#793690',
		colorTextPlaceholder: '#737373',
		colorIconCardError: '#C62828',
		colorIconCardCvcError: '#C62828',
		focusBoxShadow: 'none'
	},
	rules: {
		'.Input::placeholder': {
			fontSize: '14px',
			boxShadow: 'none'
		},
		'.Input:focus': {
			border: '1px solid #793690',
			boxShadow: 'none'
		},
		'.Input--invalid': {
			border: '1px solid #C62828',
			boxShadow: 'none'
		},
		'.Input': {
			fontSize: '14px',
			boxShadow: 'none'
		},
		'.Label': {
			fontSize: '11px',
			color: '#CCCCCC',
			fontWeight: 'bold',
			marginBottom: '8px'
		},
		'.Error': {
			color: '#C62828',
			fontSize: '10px',
			fontWeight: 'bold',
			marginTop: '4px'
		}
	}
} as stripeJs.Appearance;

export const stripeFormOptions = {
	wallets: {
		applePay: 'never',
		googlePay: 'never'
	},
	terms: {
		card: 'never'
	},
	fields: {
		billingDetails: {
			address: {
				country: 'never',
				postalCode: 'never'
			}
		}
	}
} as stripeJs.StripePaymentElementOptions;
